import { store } from "@/store/store"

export default class PageWhitelistUtils {
    isMenuOnWhiteList(name: string): boolean {
        const whitelist = store.getters.pageWhitelist as Map<string, string> | null
        if (whitelist != null) {
            const length = whitelist.get(name)?.trim().length
            if (length !== undefined && length > 0) {
                // Menu löytyi whitelistalta. Menu voidaan näyttää.
                return true
            }
        }
        return false
    }

    isSubjectOnWhiteList(name: string): boolean {
        if (name !== "") {
            const whitelist = store.getters.pageWhitelist as Map<string, string> | null
            if (whitelist != null) {
                for (const entry of whitelist) {
                    const values = entry[1].split(",")
                    for (const subject of values) {
                        if (subject.trim() === name) {
                            // Aihe löytyi whitelistalta. Sivu voidaan näyttää.
                            return true
                        }
                    }
                }
            }
        }
        return false
    }

    isUrlParamInfokartta(subTopic: string | null): boolean {
        const infokartat: any = store.getters.infokarttaRadioValues
        if (subTopic) {
            for (const element of infokartat) {
                if (element.tunniste === subTopic) {
                    return true
                }
            }
        }
        return false
    }
}
